function main_sider(){
  const mediaSlider = document.querySelector('[mediaSliderJSHandle]'),
        mainSlider = mediaSlider.querySelector('.media-gallery__master-slider'),
        verticalSlider = mediaSlider.querySelector('.media-gallery__vertical-slider'),
        width = screen.width;
  let lengthMainSlider = mainSlider.childNodes.length,
      lendthVerticalSlider = verticalSlider.childNodes.length;
  if(mediaSlider.classList.contains("desktop_only") && width > 767){
    if(lengthMainSlider > 1){
      $('.media-gallery__master-slider').slick({
        slidesToShow: 1,
        arrows: false,
        swipe: false,
        infinite: false,
        asNavFor: '.media-gallery__vertical-slider'
      })
    }
    if(lendthVerticalSlider > 1){
      $('.media-gallery__vertical-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        vertical: true,
        focusOnSelect: true,
        asNavFor: '.media-gallery__master-slider'
      })
    }
  }
  else{
    if(lengthMainSlider > 1){
      $('.media-gallery__master-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        infinite: true
      })
    }
  }
}
window.addEventListener('load', (event) =>{
  main_sider()
})
document.addEventListener('DOMContentLoaded', function() {
  main_sider()
})

setInterval(function time(){
  var d = new Date();
  var hours = 24 - d.getHours();
  var min = 60 - d.getMinutes();
  if((min + '').length == 1){
    min = '0' + min;
  }
  var sec = 60 - d.getSeconds();
  if((sec + '').length == 1){
        sec = '0' + sec;
  }
  document.querySelector('.hours').innerHTML = hours;
  document.querySelector('.minutes').innerHTML = min;
  document.querySelector('.seconds').innerHTML = sec;
  document.querySelector('.order_timer').innerHTML = min+' minutes';
}, 1000);

document.addEventListener("DOMContentLoaded",function(){

  // Desktop View Above Tabs Start
  
  var t=document.querySelectorAll(".js-product-tab"),
      e=document.querySelectorAll(".js-product-tab-content"),
      n="product-tabs__tab-link--active";
  t.length&&e.length&&t.forEach(function(r){
    r.addEventListener("click",function(o){
      if(o.preventDefault(),!r.classList.contains(n)){
        var i=r.dataset.tabId,
            a=Array.from(e).find(function(t){
              var e=t.dataset.forTabId;return i===e});
        t.forEach(function(t){
          t.classList.remove(n)});
        e.forEach(function(t){
          t.classList.contains("product-tabs__tab-content--hidden")||t.classList.add("product-tabs__tab-content--hidden")});
        r.classList.add(n);
        a.classList.remove("product-tabs__tab-content--hidden");
      }
    });
  });

  const dataStartDate=document.querySelectorAll('.js-product-delivery-estimate-start-date'), dataEndDate=document.querySelectorAll('.js-product-delivery-estimate-end-date'), dataFetchMain=document.querySelector('.js-product-delivery-estimate');
    let dataStDt= dataStartDate.getAttribute('data-min-delivery-days'), dataEndDt= dataStartDate.getAttribute('data-max-delivery-days');
    if(dataStartDate.length > 0){
      dataStartDate.innerHTML = dataStDt;
    }
    if(dataEndDate.length > 0){
      dataStartDate.innerHTML = dataEndDt;
    }

  // Desktop View Above Tabs End

  // Mobile View Above Tabs Start
  
  if($('.product-mobile-tabs__tab').hasClass('product-mobile-tabs__tab--active')){
    $('.product-mobile-tabs__tab.product-mobile-tabs__tab--active').siblings().children('.product-mobile-tabs__tab-body').slideUp();
  }
  
  $(document).on('click','.product-mobile-tabs__tab-heading',function(){
    console.log('okk')
    if(!$(this).parent('.product-mobile-tabs__tab').hasClass('product-mobile-tabs__tab--active')){
      $(this).parent('.product-mobile-tabs__tab').addClass('product-mobile-tabs__tab--active').children('.product-mobile-tabs__tab-body').slideDown().parent('.product-mobile-tabs__tab').siblings().removeClass('product-mobile-tabs__tab--active').children('.product-mobile-tabs__tab-body').slideUp();
    }
    else{
      $(this).parent('.product-mobile-tabs__tab').removeClass('product-mobile-tabs__tab--active').children('.product-mobile-tabs__tab-body').slideUp().parent('.product-mobile-tabs__tab').siblings().removeClass('product-mobile-tabs__tab--active').children('.product-mobile-tabs__tab-body').slideUp();
    }
  })

  // Mobile View Above Tabs End
  
});